import { render, staticRenderFns } from "./EBtn.vue?vue&type=template&id=e24e0f50&"
import script from "./EBtn.vue?vue&type=script&lang=ts&"
export * from "./EBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports